// frontend/src/components/OrderConfirmation.js

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import './OrderConfirmation.css';

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch order details
    const fetchOrder = async () => {
      try {
        const response = await api.get(`/api/orders/${orderId}`);
        setOrder(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching order:', err);
        setError('Unable to load order details. Please contact customer support.');
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId]);

  if (loading) return <div className="loading">Loading order details...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!order) return <div className="error">Order not found</div>;

  // Format date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="order-confirmation">
      <div className="confirmation-container">
        <div className="confirmation-header">
          <div className="success-icon">
            <svg viewBox="0 0 24 24" width="64" height="64">
              <path
                fill="#4CAF50"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              />
            </svg>
          </div>
          <h1>Order Confirmed!</h1>
          <p>Thank you for your purchase</p>
        </div>

        <div className="order-details">
          <div className="order-info">
            <div className="order-info-row">
              <span>Order Number:</span>
              <span>{order._id}</span>
            </div>
            <div className="order-info-row">
              <span>Date:</span>
              <span>{formatDate(order.createdAt)}</span>
            </div>
            <div className="order-info-row">
              <span>Status:</span>
              <span className={`status-${order.status}`}>{order.status}</span>
            </div>
          </div>

          <div className="order-items">
            <h2>Order Summary</h2>
              {order.items.map((item, index) => (
                <div key={index} className="order-item">
                  <div className="item-details">
                    <h3>{item.name}</h3>
                    <div className="item-price">
                      <span>${item.price.toFixed(2)}</span>
                      <span>Qty: {item.quantity}</span>
                    </div>
                  </div>
                  <div className="item-total">
                    ${(item.price * item.quantity).toFixed(2)}
                  </div>
                </div>
              ))}
              <div className="order-total">
                <span>Total</span>
                <span>${order.totalAmount.toFixed(2)}</span>
              </div>
          </div>

          <div className="shipping-details">
            <h2>Shipping Information</h2>
            {order.shippingAddress ? (
              <>
                <p>{order.shippingAddress.name}</p>
                <p>{order.shippingAddress.addressLine1}</p>
                {order.shippingAddress.addressLine2 && (
                  <p>{order.shippingAddress.addressLine2}</p>
                )}
                <p>
                  {order.shippingAddress.city}, {order.shippingAddress.state}{' '}
                  {order.shippingAddress.postalCode}
                </p>
                <p>{order.shippingAddress.country}</p>
              </>
            ) : (
              <p>Shipping address not available</p>
            )}
          </div>
        </div>

        <div className="confirmation-footer">
          <p>
            We've sent a confirmation email with all the details of your order.
          </p>
          <div className="action-buttons">
            <Link to="/" className="button primary">
              Continue Shopping
            </Link>
            {/* TODO: Implement order history functionality later */}
            {/* <Link to="/my-orders" className="button secondary">
              View My Orders
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;